import React from 'react'
import { Button, Card, Col, Row, Typography } from 'antd'
import { CheckCircleOutlined } from '@ant-design/icons'
import { UserMessageView } from 'components/elements'
import { useDispatch } from 'react-redux'
import { billingActions } from 'store/billingSlice/billingReducer'
import { config } from 'configs'

const { Text } = Typography
const TierSelection = ({ tiers }) => {
  const dispatch = useDispatch()

  const handleTierSelection = (tierId) => {
    const tier = tiers?.find((t) => t.TierId === tierId)
    dispatch(billingActions.setTier(tier))
  }

  const nonCustomTiers = tiers?.filter((tier) => !tier.Customizable)
  const customTier = tiers?.find((tier) => tier.Customizable === true)
  return (
    <>
      {tiers && tiers?.length > 0 ? (
        <div className="t-p-4 md:t-p-7 md:t-pt-3">
          <Row className="t-p-[10px]">
            <Text strong className="t-font-roboto t-text-[1.625rem]">
              Explore our plans
            </Text>
          </Row>
          {nonCustomTiers && nonCustomTiers?.length > 0 && (
            <Row gutter={16} justify="center">
              {nonCustomTiers?.map((tier, indexCard) => (
                <Col key={indexCard} xs={24} sm={24} md={8} xl={8}>
                  <Card
                    key={indexCard}
                    className="t-relative t-px-4 t-py-5 hover:t-border-[#1BA1E2] t-border-[2px]"
                  >
                    {tier?.MostPopular && (
                      <div className="t-bg-[#1BA1E2] t-rounded-full t-w-[fit-content] t-px-4 t-py-2 t-absolute -t-top-[1.1rem] t-left-1/2 t-transform t--translate-x-1/2">
                        <Typography className="t-font-roboto t-text-white t-text-[1rem] md:t-text-[1.125rem] t-font-bold t-leading-[1 md:t-leading-[1.3125rem] t-text-center">
                          Most Popular
                        </Typography>
                      </div>
                    )}
                    <Typography className="t-font-roboto t-text-[2rem] md:t-text-[2.375rem] t-font-extrabold t-leading-[2.35rem] md:t-leading-[2.783125rem] t-text-center t-mb-2">
                      {tier.TierName}
                    </Typography>
                    <Typography className="t-font-roboto t-text-[1.125rem] md:t-text-[1.375rem] t-leading-[1.3rem] md:t-leading-[1.61125rem] t-text-center">
                      {tier.Description}
                    </Typography>
                    <Typography className="t-font-roboto t-text-[1.125rem] md:t-text-[1.375rem] t-leading-[1.3rem] md:t-leading-[1.61125rem] t-text-center t-my-6 md:t-my-10">
                      <span className="t-font-roboto t-text-[3rem] md:t-text-[4.5rem] t-font-extrabold t-leading-[3.5rem] md:t-leading-[5.27375rem]">
                        ${tier.BaseFee}
                      </span>
                      /Month
                    </Typography>
                    <Button
                      type="primary"
                      size="large"
                      className="t-w-full t-h-[3rem] md:t-h-[3.625rem] t-bg-[#1BA1E2] t-border-[#1BA1E2] t-text-[1.25rem] md:t-text-[1.5rem] t-leading-[1.25rem] md:t-leading-[1.375rem]"
                      onClick={() => handleTierSelection(tier.TierId)}
                    >
                      Try for free
                    </Button>
                    <Typography className="t-text-roboto t-text-[1.125rem] md:t-text-[1.375rem] t-font-semibold t-leading-[1.3rem] md:t-leading-[1.5625rem] t-mt-[2rem] md:t-mt-[2.5625rem] t-mb-[1rem] md:t-mb-[1.375rem]">
                      What’s include on starter
                    </Typography>
                    <Row gutter={[0, 10]}>
                      {tier?.Features?.map((desc, index) => (
                        <div
                          className="t-flex t-justify-start t-items-start t-space-x-4"
                          key={index}
                        >
                          <CheckCircleOutlined
                            style={{ fontSize: '1rem' }}
                            className="t-text-[#1BA1E2]"
                          />
                          <Typography className="t-text-roboto t-text-[1rem] md:t-text-[1.125rem] t-leading-[1.2rem] md:t-leading-[1.318125rem]">
                            {desc}
                          </Typography>
                        </div>
                      ))}
                    </Row>
                  </Card>
                </Col>
              ))}
            </Row>
          )}
          {customTier ? (
            <Row>
              <Card className="t-mt-8 t-relative t-px-4 t-py-5 hover:t-border-[#1BA1E2] t-border-[2px]">
                <Row gutter={16} justify="center">
                  <Col span={16}>
                    <Typography className="t-text-roboto t-text-[1.125rem] md:t-text-[1.375rem] t-font-semibold t-leading-[1.3rem] md:t-leading-[1.5625rem] t-mb-[1rem] md:t-mb-[1.375rem]">
                      What’s include on starter
                    </Typography>
                    <Row gutter={[0, 10]}>
                      {customTier?.Features?.map((desc, index) => (
                        <Col
                          span={12}
                          className="t-flex t-justify-start t-items-start t-space-x-4"
                          key={index}
                        >
                          <CheckCircleOutlined
                            style={{ fontSize: '1rem' }}
                            className="t-text-[#1BA1E2]"
                          />
                          <Typography className="t-text-roboto t-text-[1rem] md:t-text-[1.125rem] t-leading-[1.2rem] md:t-leading-[1.318125rem]">
                            {desc}
                          </Typography>
                        </Col>
                      ))}
                    </Row>
                  </Col>
                  <Col span={8}>
                    <Typography className="t-font-roboto t-text-[2rem] md:t-text-[2.375rem] t-font-extrabold t-leading-[2.35rem] md:t-leading-[2.783125rem] t-text-center t-mb-2">
                      {customTier.TierName}
                    </Typography>
                    <Typography className="t-font-roboto t-text-[1.125rem] md:t-text-[1.375rem] t-leading-[1.3rem] md:t-leading-[1.61125rem] t-text-center">
                      {customTier.Description}
                    </Typography>
                    <Typography className="t-font-roboto t-text-[1.125rem] md:t-text-[1.375rem] t-leading-[1.3rem] md:t-leading-[1.61125rem] t-text-center t-my-6 md:t-my-10">
                      <span className="t-font-roboto t-text-[3rem] md:t-text-[4.5rem] t-font-extrabold t-leading-[3.5rem] md:t-leading-[5.27375rem]">
                        ${customTier.BaseFee}
                      </span>
                      /Month
                    </Typography>
                    <Button
                      type="primary"
                      size="large"
                      className="t-w-full t-h-[3rem] md:t-h-[3.625rem] t-bg-[#1BA1E2] t-border-[#1BA1E2] t-text-[1.25rem] md:t-text-[1.5rem] t-leading-[1.25rem] md:t-leading-[1.375rem]"
                      onClick={() => handleTierSelection(customTier.TierId)}
                    >
                      Try for free
                    </Button>
                  </Col>
                </Row>
              </Card>
            </Row>
          ) : (
            <Row>
              <Col span={24}>
                <Typography className="t-mt-8 t-font-roboto t-text-[1.125rem] md:t-text-[1.375rem] t-leading-[1.3rem] md:t-leading-[1.61125rem]">
                  To get started with a custom plan, please{' '}
                  <span
                    className="t-text-[#1BA1E2] t-font-semibold t-cursor-pointer"
                    onClick={() => window.open(config.getHelpUrl, '_blank')}
                  >
                    contact support
                  </span>
                </Typography>
              </Col>
            </Row>
          )}
        </div>
      ) : (
        <UserMessageView
          heading="Something went wrong"
          subHeading="Please try again later or contact support"
        />
      )}
    </>
  )
}

export { TierSelection }
